export const PaymentType = {
  CREDIT_CARD: 'CREDIT_CARD',
  ACH: 'ACH',
} as const;

export type PaymentType = keyof typeof PaymentType;
